module.exports = __webpack_public_path__ + "static/img/14000069.fc19eb4c.png";